import { makeAutoObservable } from "mobx";
import { FetchShelf } from "../../shelves";
import type { AuthenticationStore } from "../../stores";
import type { apiTypes } from "../../services";
import { api } from "../../services";

export class PostBalanceInquiryRequestFetchStore {
	public fetchShelf: FetchShelf<apiTypes.BalanceInquiryRequest>;

	constructor(
		public authentication: AuthenticationStore,
		onSuccessFetch: VoidFunction,
	) {
		this.fetchShelf = new FetchShelf(
			async () => api.postBalanceInquiryRequest(this.authentication.getToken() || ""),
			onSuccessFetch,
		);

		makeAutoObservable(this);
	}
}
